$(document).ready(function () {
    console.log('Cart limiter loaded!');

    function handleCartChange(cart) {
        var totalCount = cart.item_count;
        var currentTotalQuantity = 0;

        for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].quantity > 5) {
                currentTotalQuantity = 1;
            }
        }

        $('.cart-limit-reached').remove();

        if (currentTotalQuantity == 1 || totalCount > 20) {
            $('#slidecart-checkout-form button').prop('disabled', true);
            $('#slidecart-checkout-form').before(`<p class="cart-limit-reached">${cartStrings.limitReached}</p>`);
            $('.footer-continue').html('Sie können nicht mehr als 7 Produkte kaufen');
        } else {
            $('#slidecart-checkout-form button').prop('disabled', false);
            $('.footer-continue').html('Oder weiter einkaufen');
        }

        $('.wt-header__panel__counter').html(totalCount);
        if (totalCount > 0) {
            $('.wt-header__panel__counter').show();
        } else {
            $('.wt-header__panel__counter').hide();
        }

        const cartLoadedEvent = new CustomEvent("cart-loaded", {
            detail: cart
        });

        document.dispatchEvent(cartLoadedEvent);
    }

    // Fetch the cart once; if another refresh is asked for while one is in flight, run one
    // more afterwards so the last cart change is never missed.
    var inFlight = false, again = false;
    function orderLimiter() {
        if (inFlight) { again = true; return; }
        inFlight = true;
        jQuery.getJSON("/cart.js", function (cart) {
            handleCartChange(cart);
        }).always(function () {
            inFlight = false;
            if (again) { again = false; orderLimiter(); }
        });
    }

    // When to refresh. This used to poll /cart.js every second on every page for as long as
    // it was open (the old note here already warned it could saturate the network). Now:
    //  - once on load,
    //  - whenever any script on the page changes the cart (theme add-to-cart, Slide Cart,
    //    Kaching, quick add...). Watched via resource timing, so it sees fetch and XHR calls
    //    to /cart/add|change|update|clear from every app, whichever way it sends them,
    //  - when the visitor comes back to the tab or the page is restored from the back/forward
    //    cache (the cart may have changed in another tab).
    // If the browser can't watch requests, fall back to the old once-a-second polling.
    orderLimiter();
    var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js(on)?)?(\?|$)/;
    var watching = false;
    if ('PerformanceObserver' in window) {
        try {
            new PerformanceObserver(function (list) {
                if (list.getEntries().some(function (e) { return CART_CHANGE.test(e.name); })) orderLimiter();
            }).observe({ type: 'resource' });
            watching = true;
        } catch (e) {}
    }
    if (!watching) setInterval(orderLimiter, 1000);
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') orderLimiter();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) orderLimiter(); });
});

/* Subscribe & save stays at 1 unit in the cart (goes with assets/subscription-single-only.js, Oct 2026).
   Kaching gives its Duo/Trio % to any cart line with 2+ units, subscription or not, so a subscription
   raised to 2–3 in the cart would get both discounts. So:
   - Slide Cart drawer: the -/1/+ box is hidden on those subscription lines (× remove still works).
   - Safety net: if one still has 2+ (e.g. the same subscription added twice from the product page),
     it is set back to 1 and a short note shows above Checkout for a few seconds.
   Only lines carrying Kaching's `__kaching_bundles` property: the inositol landing page sells 2–3 unit
   subscriptions on purpose without it. Runs on the `cart-loaded` event above (after every cart change),
   so it makes no extra cart requests of its own. CSS: custom_sitewide.css (.rb-sub-locked, .rb-sub-qty-note). */
(function () {
    'use strict';

    var NOTES = {
        de: 'Das Abo ist auf 1 Dose pro Lieferung begrenzt.',
        en: 'Subscribe & save is limited to 1 unit per delivery.',
        fr: "L'abonnement est limité à 1 unité par livraison.",
        es: 'La suscripción está limitada a 1 unidad por envío.',
        it: "L'abbonamento è limitato a 1 unità per consegna."
    };
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var lastCart = null;
    var fixing = false;

    function isBundleSubscription(item) {
        return !!item.selling_plan_allocation && !!(item.properties && item.properties.__kaching_bundles);
    }

    // Drawer lines are in cart order; the line's delivery text (the plan name) is checked too,
    // so a mismatch never hides the wrong box.
    function lockRows() {
        var root = document.getElementById('slidecarthq');
        if (!root || !lastCart) return;
        var boxes = root.querySelectorAll('.quantity-selector');
        var items = lastCart.items || [];
        for (var i = 0; i < boxes.length; i++) {
            var item = boxes.length === items.length ? items[i] : null;
            var row = boxes[i].closest('.main') || boxes[i].parentElement;
            var lock = !!item && isBundleSubscription(item) &&
                       row.textContent.indexOf(item.selling_plan_allocation.selling_plan.name) !== -1;
            if (boxes[i].classList.contains('rb-sub-locked') !== lock) boxes[i].classList.toggle('rb-sub-locked', lock);
        }
    }

    function showNote() {
        var form = document.getElementById('slidecart-checkout-form');
        if (!form) return;
        var note = document.querySelector('.rb-sub-qty-note');
        if (!note) { note = document.createElement('p'); note.className = 'rb-sub-qty-note'; }
        note.textContent = NOTES[lang] || NOTES.en;
        form.parentNode.insertBefore(note, form);
        clearTimeout(showNote.timer);
        showNote.timer = setTimeout(function () { note.remove(); }, 12000);
    }

    function check(cart) {
        lastCart = cart;
        lockRows();
        if (fixing) return;
        var tooMany = (cart.items || []).filter(function (item) {
            return isBundleSubscription(item) && item.quantity > 1;
        });
        if (!tooMany.length) return;
        fixing = true;
        Promise.all(tooMany.map(function (item) {
            return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 1 })
            });
        }))
            .then(function () { if (window.SLIDECART_UPDATE) return window.SLIDECART_UPDATE(); })
            .catch(function () {})
            .then(function () { fixing = false; showNote(); });
    }

    document.addEventListener('cart-loaded', function (e) {
        if (e.detail && e.detail.items) check(e.detail);
    });

    // The drawer redraws itself on every update; re-hide the boxes after each redraw.
    var queued = false;
    new MutationObserver(function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; lockRows(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
})();
